/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:fad935c9-ccc9-4d93-a29b-c2aab68470dc",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_XjljcdQQK",
    "aws_user_pools_web_client_id": "6m8fumdkqs1r14o4ur6ip0hau",
    "oauth": {}
};


export default awsmobile;
